import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

import { formSelector } from '@xcritical/forms';

import { useRegistry } from '@crm-framework/registry';
import { Label } from '@crm-framework/label';
import { ITabsProps, Tabs } from '@crm-framework/tabs';

import { IDescriptionProps, IText } from '../../types';
import { PROMO_FORM_NAME, PROMO_REGISTRIES, PROMO_TABS } from '../../consts';

import { MyAccountTabs } from './MyAccount';
import { EmailTabs } from './Email';

export const Description: React.FC<IDescriptionProps> = ({ disabled }) => {
  const texts: IText[] = useSelector((state) => {
    const form = formSelector(state, PROMO_FORM_NAME);

    return get(form, ['model', 'texts'], []);
  });
  const activeTab = useRegistry<ITabsProps['activeTab']>(
    PROMO_REGISTRIES.ACTIVE_TAB
  );

  const tabs = useMemo(
    () => [
      {
        label: () => <Label lineHeight="0px">{PROMO_TABS.myAccount}</Label>,
        component: () => <MyAccountTabs disabled={disabled} texts={texts} />,
      },
      {
        label: () => <Label lineHeight="0px">{PROMO_TABS.email}</Label>,
        component: () => <EmailTabs disabled={disabled} texts={texts} />,
      },
    ],
    [disabled]
  );

  return <Tabs activeTab={activeTab} items={tabs} />;
};
